export const ALASKA_SITE_ID = 500053;
export const PAL_US_SITE_ID = 500081;
export const PAL_AU_SITE_ID = 500083;
export const PAL_CA_SITE_ID = 500084;